export default class TutorialSlide {
  constructor({ firstText, secondText, tipText, noteText }) {
    this.firstText = firstText;
    this.secondText = secondText;
    this.tipText = tipText;
    this.noteText = noteText;
  }
}
